module.exports = __webpack_public_path__ + "img/p18.a65e49bb.jpg";